import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { CTASection } from "../components/site/CTASection";
import { EXPERTISE } from "../data/expertise";

export default function ExpertiseOverview() {
  return (
    <div>
      <PageHero
        variant="light"
        label="Expertise"
        title="Industrial Expertise"
        intro="MATRIVON's perspective is grounded in direct experience across industrial production, formulation, technical sales, international business development and management."
        crumbs={[{ label: "Expertise" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2">
            {EXPERTISE.map((e) => (
              <Link
                key={e.slug}
                to={`/expertise/${e.slug}`}
                data-testid={`expertise-item-${e.slug}`}
                className="group flex flex-col bg-white p-8 transition-colors hover:bg-brand-blue/[0.03]"
              >
                <h2 className="font-heading text-xl font-bold text-brand-ink group-hover:text-brand-blue">
                  {e.title}
                </h2>
                <p className="mt-3 flex-1 text-[15px] leading-relaxed text-brand-muted">{e.short}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
                  Explore <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
            <div className="flex items-center bg-brand-ink p-8 text-white">
              <p className="font-heading text-lg leading-snug">
                Understand the technology, understand the market, then assess what makes commercial
                sense.
              </p>
            </div>
          </div>
        </div>
      </section>

      <CTASection secondary={{ to: "/advisory", label: "See Advisory Services" }} />
    </div>
  );
}
